
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Brain } from "lucide-react";
import { InvenioLogo } from "@/components/ui/invenio-logo";
import EnhancedBetaSignupForm from "./EnhancedBetaSignupForm";

const MarketingNavigation = () => {
  return (
    <nav className="border-b border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 sticky top-0 z-50">
      <div className="container mx-auto flex h-16 items-center justify-between px-4">
        <div className="flex items-center space-x-2">
          <InvenioLogo className="h-8 w-auto text-primary" />
          <span className="font-bold text-xl text-foreground">InvenioCRM</span>
          <Badge variant="secondary" className="bg-primary/10 text-primary border-primary/20">
            <Brain className="h-3 w-3 mr-1" />
            AI-Native
          </Badge>
        </div>

        <div className="flex items-center space-x-4">
          <Link to="/auth">
            <Button variant="ghost" size="sm" className="text-foreground hover:text-foreground/80">
              Sign In
            </Button>
          </Link>
          <EnhancedBetaSignupForm 
            trigger={
              <Button size="sm" className="bg-primary hover:bg-primary/90 text-primary-foreground">
                Join our Beta Waitlist
              </Button>
            }
            source="nav_cta_button"
          />
        </div>
      </div>
    </nav>
  );
};

export default MarketingNavigation;
